export default __webpack_public_path__ + "static/media/table-download-icon.70f3d024.svg";